import { RouteName } from "constant/routeNames";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CreatorQueueListSkeleton from "components/skeleton/CreatorQueueListSkeleton";
import LazyLoadImg from "components/LazyLoadImg";

function PlaylistQueueCard({
  setEpisodeDetails,
  video,
  season,
  setVideoDetails,
  id,
  slug,
}: any) {
  const navigate = useNavigate();
  const { currentVideo } = useSelector((state: any) => state?.video);

  const isActive = currentVideo?.id === id;

  const episodeOnClick = () => {
    navigate(
      RouteName.CreatorPlaylistRoute.replace(":slug", slug).replace(
        ":stream",
        video?.stream_key
      )
    );
    setEpisodeDetails(video);
    setVideoDetails(video);
  };

  return (
    <>
      <div
        className={`group flex w-full cursor-pointer items-center gap-4 rounded-xl px-3 py-3 transition-all duration-300 max-sm:my-0 max-sm:w-full ${
          isActive
            ? "bg-[var(--red)]/10 ring-1 ring-[var(--red)]/40"
            : "hover:bg-white/[0.05]"
        }`}
        onClick={episodeOnClick}
      >
        <div className="relative aspect-video h-[72px] w-[128px] shrink-0 overflow-hidden rounded-lg ring-1 ring-white/10 transition-all duration-300 group-hover:ring-[var(--red)]/40 max-sm:h-[64px] max-sm:w-[110px]">
          <LazyLoadImg
            imgSrc={video?.thumbnail_url}
            imgAlt={"Artist"}
            imgHeight={"100%"}
            imgWidth={"100%"}
            wrapperProps={{
              style: {
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                display: "block",
              },
            }}
            className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-110"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
            }}
          />
          <div className="absolute inset-x-0 bottom-0 flex justify-end p-1.5">
            <p className="rounded bg-black/60 px-1.5 py-0.5 text-[10px] font-medium text-white backdrop-blur-sm">
              {video?.runtime} min
            </p>
          </div>
        </div>

        <div className="min-w-0 flex-1">
          {isActive && (
            <p className="mb-1 flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-wide text-[var(--red)]">
              <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[var(--red)]" />
              Now Playing
            </p>
          )}
          <p
            className={`line-clamp-2 text-[13px] leading-snug transition-colors ${
              isActive ? "font-semibold text-white" : "text-white/90 group-hover:text-white"
            }`}
          >
            {video?.title}
          </p>
        </div>
      </div>
    </>
  );
}

export default PlaylistQueueCard;